/**
 * 專案刪除權限（後端 pm-backend services/pmProjectService.ts deleteProject 同一套規則，兩邊要一起改）
 * - 管理員（SUPER_ADMIN、ADMIN）：全部
 * - USER：只能刪自己建立的
 * PM 的專案、需求、任務等是組織內協作資料，編輯不限建立者（後端同樣不檢查）
 */
import { Role } from '@redpanda/types';

export const canDeleteProject = (project: { userId?: string }, userRole?: string, currentUserId?: string): boolean =>
  userRole === Role.SUPER_ADMIN ||
  userRole === Role.ADMIN ||
  (!!currentUserId && project.userId === currentUserId);
